const Create = () => {
    return ( 
        <div className="create">
            <h2>Add new Blog</h2>
        </div>
     );
}
 
export default Create;